import saveFile from '@/services/saveFile';
import { getFileNameFromHeader } from '../utils';

function tryGetFilename(response) {
  const filename = getFileNameFromHeader(response) || response.config.filename;
  if (!filename) {
    throw new Error('Não foi possível definir o nome do arquivo');
  }
  return filename;
}

function isBlobResponseTypeAndJsonDataType(error) {
  const dataType = error.response?.data?.type || '';
  return error.request?.responseType === 'blob'
    && error.response?.data instanceof Blob
    && dataType.toLowerCase().indexOf('json') !== -1;
}

function handleJsonResponse(error) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // eslint-disable-next-line no-param-reassign
      error.response.data = JSON.parse(reader.result);
      resolve(Promise.reject(error));
    };
    reader.onerror = () => {
      reject(error);
    };
    reader.readAsText(error.response.data);
  });
}

function onFulfilled(response = {}) {
  if (response.status !== 200) {
    return response;
  }
  const filename = tryGetFilename(response);
  saveFile(filename, new Blob([response.data]));
  return response;
}

function onRejected(error) {
  if (isBlobResponseTypeAndJsonDataType(error)) {
    return handleJsonResponse(error);
  }
  return Promise.reject(error);
}

export default function downloadBuilder(instance) {
  instance.interceptors.request.use(config => ({
    ...config,
    responseType: 'blob',
  }));

  instance.interceptors.response.use(
    response => onFulfilled(response),
    error => onRejected(error),
  );
}
